import React, { Component } from 'react';
import Header from './Layout/Header';
import SeatBookingTable from './SeatBooking/SeatBookingTable';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import { connect } from 'react-redux';
import Sidebar from '../Component/Layout/Sidebar';
import CustomHeader from '../Component/Layout/Header';
import { Layout } from 'antd';
import {
  SeatBookingData,
  SeatBookingGraphData,
  SeatBookingKpiData,
  CheckLoader,
} from '../Redux/action/seatBookingAction';
import SeatBookingFilter from './SeatBooking/SeatBookingFilter';
import SeatbookingShort from './SeatBooking/SeatbookingShort';
import { CSVLink } from 'react-csv';
import { Navigate } from 'react-router-dom';
import { dataUser, logoutHandler, dataLocation } from './Helpers/util';
import axios from 'axios';
import SeatBookingFilterExport from './SeatBooking/SeatBookingFilterExport';
import SwInput from './Common/FormComponent/SwInput';
import SwKpiGroup from './Common/SwKPI/SwKpiGroup';
import SwKpi from './Common/SwKPI/SwKPI';
const apiURL = require('./../constant');
const URL_API = apiURL.PROD_URL;

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
var totalSeats;
var dt = new Date();
var month = dt.getMonth() + 1;
var year = dt.getFullYear();

var daysInMonth = new Date(year, month, 0).getDate();

var getData = null;

class SeatBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      row: '25',
      collapsed: true,
      filterData: {},
      SortData: '',
      pgno: 1,
      type: '',
      isSearchVisible: false,
      searchText: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      totalSeats: 0,
      accessServiceLists: [],
      loaderServiceAccess: true,
      locationfilter: [],
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
  }

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };

  toggleCollapsed = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };

  shortSelectData = shortallkey => {
    this.setState({
      SortData: shortallkey,
    });
  };

  handleLanguage = langValue => {
    this.setState({
      filterData: langValue,
    });
  };

  setPage = e => {
    this.setState({
      pgno: 1,
      row: this.state.row,
    });
  };

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
    });
    let parms = {
      order: this.state.SortData,
      company_id: this.state.company_id,
      ...this.state.filterData,
      row: this.state.row,
      pgno: this.state.pgno + 1,
      search: this.state.searchText,
      location: this.state.filterData.location
        ? this.state.filterData.location
        : JSON.stringify(LocationObj),
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.SeatBookingData(parms);
  }

  pageBackword() {
    this.setState({
      pgno: this.state.pgno - 1,
    });
    let parms = {
      order: this.state.SortData,
      company_id: this.state.company_id,
      ...this.state.filterData,
      row: this.state.row,
      pgno: this.state.pgno - 1,
      search: this.state.searchText,
      location: this.state.filterData.location
        ? this.state.filterData.location
        : JSON.stringify(LocationObj),
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.SeatBookingData(parms);
  }

  changeFilterData = event => {
    this.setState({ searchText: event.target.value }, () => {
      let params = {
        pgno: 1,
        order: this.state.SortData,
        company_id: this.state.company_id,
        row: this.state.row,
        search: this.state.searchText,
        location: JSON.stringify(LocationObj),
      };
      if (!UserObj?.company_id) {
        logoutHandler();
      }
      if (getData) clearTimeout(getData);
      getData = setTimeout(() => {
        this.props.CheckLoader();
        this.props.SeatBookingData(params);
      }, 1000);
    });
  };

  clearSearchBox = () => {
    this.setState({ searchText: '' });
  };

  setuserlist = () => {
    const params = {
      pgno: 1,
      order: this.state.SortData,
      company_id: this.state.company_id,
      row: this.state.row,
      location: JSON.stringify(LocationObj),
    };
    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.SeatBookingData(params);
    // this.props.SeatBookingGraphData(params);
    // this.props.SeatBookingKpiData(params)
  };

  selectRows = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    const params = {
      ...this.state.filterData,
      order: this.state.SortData,
      pgno: this.state.pgno,
      row: e.target.value,
      company_id: this.state.company_id,
      location: this.state.filterData.location
        ? this.state.filterData.location
        : JSON.stringify(LocationObj),
    };
    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.SeatBookingData(params);
  };

  // getFlexiFixedData = async () => {
  //   try {
  //     let dataAry = { company_id: UserObj.company_id };
  //     await axios
  //       .post(URL_API + 'api/v1/user/flexi_count', dataAry)
  //       .then(res => {
  //         let toseatdata = res.data.data;

  //         this.setState({
  //           totalSeats: toseatdata.total,
  //         });

  //       });
  //   } catch (err) {

  //   }
  // };

  componentDidMount() {
    this.setuserlist();

    // this.getFlexiFixedData();
  }

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  };

  render() {
    const SeatBooking = this.state.userRole.find(
      element =>
        element.service_id == '15' &&
        (element.role_for_read === '1' || element.role_for_write === '1'),
    );

    const seatListData = this.props.seatBookingReducer1;
    const Loader = this.props.seatLoader.loader;
    let setDownload = this.props.seatBookingReducer.data;
    let alldata =
      setDownload && setDownload.list !== undefined ? setDownload.list : [];

    function getStatus(status) {
      if (status == 1) {
        return 'Booked';
      } else if (status == 2) {
        return 'End';
      } else if (status == 3) {
        return 'End';
      } else if (status == 4) {
        return 'Cancelled';
      } else {
        return 'Unused Booking ';
      }
    }
    function getSeatType(status) {
      if (status == 1) {
        return 'Fixed';
      } else if (status == 2) {
        return 'Flexi';
      }
    }
    var arr2 = alldata.map(v => ({
      booking_date: v.booking_date,
      category: v.category,
      city_name: v.city_name,
      seat_type: v.seat_type == '1' ? 'Fixed' : 'Flexi',
      business_name: v.business_name,
      company_name: v.company_name,
      email: v.email,
      end_time: v.end_time,
      flexi_seat_id: v.flexi_seat_id,
      floor_name: v.floor_name,
      fname: v.fname,
      lname: v.lname,
      fullName: v.fname + ' ' + v.lname,
      location_name: v.location_name,
      phone: v.phone,
      price: v.price,
      seat_type: getSeatType(v.seat_type),
      start_time: v.start_time,
      status: getStatus(v.status),
      title: v.title,
    }));

    let total =
      seatListData.data !== undefined ? Number(seatListData.data.rows) : 0;
    let roWs =
      seatListData.data !== undefined ? Number(seatListData.data.rows) : 0;
    let weekday =
      seatListData.data !== undefined ? seatListData.data.weekday : 0;
    let totalamount =
      seatListData.data !== undefined ? seatListData.data.totalamount : 0;

    let avgSeat = (total / daysInMonth / this.state.totalSeats) * 100;
    var avgPerc = avgSeat.toFixed(2);

    const headers = [
      { label: 'Seat No', key: 'title' },
      { label: 'Seat Type', key: 'seat_type' },
      { label: 'Seat Category', key: 'category' },
      { label: 'Location', key: 'location_name' },
      { label: 'User Name', key: 'fullName' },
      { label: 'Email', key: 'email' },
      { label: 'Phone No.	', key: 'phone' },
      { label: 'Booking Date', key: 'booking_date' },
      { label: 'Amount', key: 'price' },
      { label: 'Status', key: 'status' },
    ];

    const csvReport = {
      data: arr2,
      headers: headers,
      filename: 'SeatBooking_Report.csv',
    };

    let enterRos = seatListData.data && seatListData.data.rows;

    let serviceAccess = true;
    const serviceAccessId = 15;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }

    return (
      <>
        <Layout>
          <Sidebar collapsed={this.state.collapsed} />

          <CustomHeader
            collapsed={this.state.collapsed}
            toggleCollapsed={this.toggleCollapsed}
          />

          <Layout
            className={
              this.state.collapsed
                ? 'PageLayout CollapsedPageLayout'
                : 'PageLayout'
            }
          >
            <SeatBookingFilterExport />
            {serviceAccess === true ? (
              <>
                <div className="PageContent">
                  <div className="row">
                    <div className="col-md-12 col-lg-6">
                      <div className="SwHeading">
                        <h2 className='mb-0'>Seat Booking</h2>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                      <div className="PageHead_Optons_Row">
                        <ul className="PageHead_Optons_RightAligned">
                          <li>
                            <div className="SwInputWithIcon">
                              <SwInput
                                id="SBSearch"
                                placeholder="Search..."
                                value={this.state.searchText}
                                onChange={this.changeFilterData}
                              />
                              <span className="SwInputicon">
                                <i className="bi bi-search" />
                              </span>
                            </div>
                          </li>
                          <li>
                            <SeatBookingFilter
                              clearSearch={this.clearSearchBox}
                              filterRow={this.state.row}
                              filterPage={this.state.pgno}
                              onSelectLanguage={this.handleLanguage}
                            />
                          </li>
                          <li>
                            <SeatbookingShort
                              page={this.setPage}
                              pg={this.state.pgno}
                              rowName={this.props.totalCount}
                              changeshort={this.shortSelectData}
                              totalCount={this.props.totalCount}
                              BookingListExport={this.props.seatBookingReducer}
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <SwKpiGroup>
                        <SwKpi
                          label="Total Bookings"
                          value={total}
                        />

                        <SwKpi
                          label="Popular Day"
                          value={weekday}
                        />

                        <SwKpi
                          label="Total Amount"
                          value={totalamount}
                        />
                      </SwKpiGroup>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="">
                        <SeatBookingTable
                          currentPage={this.state.pgno}
                          pageSize={Number(this.state.row)}
                          totalRecords={roWs}
                          onPageChange={(page, pageSize) => {
                            this.setState({
                              pgno: page,
                              row: pageSize,
                            });

                            const parms = {
                              order: this.state.SortData,
                              company_id: this.state.company_id,
                              ...this.state.filterData,
                              row: pageSize,
                              pgno: page,
                              search: this.state.searchText,
                              location: this.state.filterData.location
                                ? this.state.filterData.location
                                : JSON.stringify(LocationObj),
                            };

                            this.props.CheckLoader();
                            this.props.SeatBookingData(parms);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : this.state.loaderServiceAccess == true ? (
              <>
                <div className="loader">
                  <img
                    className=""
                    src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                    alt="Loder"
                  />
                </div>
              </>
            ) : (
              <MarketingPanel />
            )}
          </Layout>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => ({
  seatBookingReducer1: state.seatBookingReducer.BookingList,
  seatLoader: state.seatBookingReducer,
  totalCount: state.seatBookingReducer.totalCount,
  seatBookingReducer: state.seatBookingReducer.BookingListExport,
});

const mapActionsToProps = {
  SeatBookingData,
  SeatBookingGraphData,
  SeatBookingKpiData,
  CheckLoader,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SeatBooking);
